import { apiService as api } from '@afterpaytouch/portal-api/api'
import { apiService as topaz } from '@afterpaytouch/topaz-api/api'
import { apiService as orderStatus } from '@afterpaytouch/order-status-api/api'
import { apiService as rulesApi } from '@afterpaytouch/rules-service-api/api'
import {
  createPortalApi,
  createTopazApi,
  createOrderStatusApi,
  createRulesServiceApi,
  createVerifyServiceApi,
  createVerifyServiceClient,
  createAppleGatewayApi,
} from './request'
import { appleGatewayService } from './appleGateway/apis'

export const apiService = api.setBaseQueryFn(createPortalApi())

export const { reducer: apiReducer, middleware: apiMiddleware } = apiService.service

export const topazService = topaz.setBaseQueryFn(createTopazApi())

export const orderStatusService = orderStatus.setBaseQueryFn(createOrderStatusApi())

export const rulesService = rulesApi.setBaseQueryFn(createRulesServiceApi())

export const verifyServiceApi = createVerifyServiceApi()

export const verifyServiceClient = createVerifyServiceClient()

export const appleGatewayApiService = appleGatewayService.setBaseQueryFn(createAppleGatewayApi())
